// react-router-dom components
import { useNavigate } from 'react-router-dom';

// Argon Dashboard 2 PRO MUI components
import ArgonBox from 'component/Argon/ArgonBox';
import ArgonButton from 'component/Argon/ArgonButton';

// Authentication layout components
import IllustrationLayout from 'layout/IllustrationLayout';

import useAuth from 'auth/hook/useAuth';
import logout from 'api/auth/logout';

// Image
const bgImage =
  'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg';

function SignOut() {
  const { setAuth } = useAuth();

  const navigate = useNavigate();

  const handleSubmit = () => {
    logout()
      .catch(console.error)
      .finally(() => {
        setAuth(null);
        navigate('/sign-in', { replace: true });
      });
  };

  return (
    <IllustrationLayout
      title="Signout"
      description="คุณต้องการออกจากระบบ?"
      illustration={{ image: bgImage }}
    >
      <ArgonBox mt={4} mb={1}>
        <ArgonButton color="info" size="large" fullWidth onClick={handleSubmit}>
          ยืนยัน
        </ArgonButton>
      </ArgonBox>
    </IllustrationLayout>
  );
}

export default SignOut;
